import styled from 'styled-components'

export const JobInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`
